import { render, staticRenderFns } from "./DashboardUser.vue?vue&type=template&id=f9a0d72e&"
import script from "./DashboardUser.vue?vue&type=script&lang=ts&"
export * from "./DashboardUser.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardUser.vue?vue&type=style&index=0&id=f9a0d72e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports